import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CreateFolderController } from '@commoncore/controller/CreateFolderController';
import { FoldersViewController } from '@commoncore/controller/FoldersViewController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';

@Component({
  standalone:true,
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss'],
  imports:[CommonModule]
})
export class CreateFolderComponent implements OnInit {
  public listService:any;
  public universalService:any;
  public buttonText:any="";
  public controller:any;
  public implRef:any;
  cleverTapEventsService: CleverTapEventsService;

  @Input() enableButton;
  @Output() closecreateModal = new EventEmitter();
  @Output() createFolderValidation = new EventEmitter();
  @Output() createFolderMove = new EventEmitter();
  @Output() createFolderCopy = new EventEmitter();
  @Output() gotoPreviousScreen = new EventEmitter();
  @Output() createFolderAdd = new EventEmitter();
  @ViewChild('folderName') folderName: ElementRef;
  localStorageSvc: LocalStorageSvc
  loggerService: any;
  sessionStorageService:any;
  //showCreateFolderModal:boolean = false;
  constructor(public globalService:GlobalService,
    private  changeDetector:ChangeDetectorRef) { 
    this.setEnvObjects(globalService)
  }

   
ngOnInit(): void {
    let classRef = this;
    if(!this.universalService.show2FApopUp && !window.location.href.includes("privatefolder"))
      this.universalService.disableModalBackdrop();
    (<HTMLInputElement>document.getElementById("folderName")).value = '';
    this.controller=CreateFolderController.getInstance(this.globalService);
    this.implRef = this.controller.createFolderImplementation;
    this.controller.setEnvObjects(this.globalService);
    this.implRef.foldersController = FoldersViewController.getInstance(this.globalService)
    this.implRef.folderViewImplf = this.implRef.foldersController.folderViewImplementation;
   
    AppEvents.globalObservable.subscribe(event => { 
      if(event["createFolder"]){
        if(classRef.folderName.nativeElement){
          classRef.folderName.nativeElement.value = "";
        }
        classRef.universalService.showCreateFolderModal = event["createFolder"];
        classRef.setButtonText();
        setTimeout(()=>{
          $(document).off('focusin.modal');
          (<HTMLInputElement>document.getElementById("folderName")).focus();
        },0)
        this.changeDetector.detectChanges()
      }else if(event["closeAll"] || event["createFolder"]== false){
        classRef.universalService.showCreateFolderModal = false;
        this.changeDetector.detectChanges()
      }
    })
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.universalService.showCreateFolderModal) {
     // this.listService.deSelectAll(event)
      this.universalService.errorMessage = '';
      this.universalService.showCreateFolderModal = false;
      this.listService.createFolderObject  = false;
      this.universalService.disableModalBackdrop();
      AppEvents.globalObservable.next({createFolder:false});
      event.stopImmediatePropagation();
      // if(this.universalService.popUpToBeOpened == "create Folder" || this.universalService.popUpToBeOpened == "copyPopUp" || this.universalService.popUpToBeOpened == "movePopUp"){
      //   this.listService.deSelectAll(event)
      // }
    } 
    
  }

  setEnvObjects(globalService){
    this.listService = globalService.getListServiceRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef()
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
  }
  

  closeCreateModal(){
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
    (<HTMLInputElement>document.getElementById("folderName")).value = '';
    //this.closecreateModal.emit(); 
    this.universalService.showCreateFolderModal = false;
    this.listService.createFolderObject  = false;
    AppEvents.globalObservable.next({createFolder:false});
    this.universalService.disableModalBackdrop();
    if(this.universalService.popUpToBeOpened == "create Folder"){
      this.listService.deSelectAll(event)
    }
  }


  validateBeforeCreatingFolder(value){
    this.createFolderValidation.emit(value)
  }

  createFolderAndMove(){
    this.universalService.showLoader = true;
    this.universalService.onMoveFolderCreationSameFolder = false;
    this.createFolderMove.emit();
  }
  
  createFolderAndCopy(){
    this.universalService.showLoader = true;
    this.createFolderCopy.emit();
    // this.showCreateFolderModal = false;
  }

  createFolderAndAdd(){
    this.universalService.showLoader = true;
    this.createFolderAdd.emit();
  }

  goBackToPreviousScreen(){
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
    this.gotoPreviousScreen.emit();
    this.universalService.showCreateFolderModal = false;
    this.listService.createFolderObject  = false;
    AppEvents.globalObservable.next({createFolder:false});
  }

  async createFolder(folderName){
    folderName = folderName.trim();
    this.universalService.createFolderApiResponse=""
    if(this.universalService.popUpToBeOpened == 'movePopUp'){
      // await this.controller.createFolder(folderName);
      this.createFolderAndMove();
    }else if(this.universalService.popUpToBeOpened == 'copyPopUp'){
        // await this.controller.createFolder(folderName);
        this.createFolderAndCopy();
    }else if(this.universalService.popUpToBeOpened == "addToJioCloud"){
      this.cleverTapEventsService.FileAddedtoJioCloud();
      this.createFolderAndAdd();
    }else if(this.universalService.popUpToBeOpened == 'create Folder'){
      const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
      const privateFolderKey = this.localStorageSvc.getPrivateFolderKey();
      const currentPrivateFolderKey = this.sessionStorageService.getCurrentPrivateFolderKey(true) == false? "":this.sessionStorageService.getCurrentPrivateFolderKey(true);

      if(this.universalService.currentTab == "PrivateFolder"){
        if( currentPrivateFolderKey!="" && currentPrivateFolderKey!=privateFolderKey ){
          this.listService.parentFolderKey = currentPrivateFolderKey
        }else{
          this.listService.parentFolderKey = privateFolderKey
        }
      }else{
        if(currentFolderKey){
          this.listService.parentFolderKey = currentFolderKey
        } else{
          this.listService.parentFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
        }
      }
     
      this.controller.createFolder(folderName);
    }
  }

  setButtonText(){
    if(this.universalService.popUpToBeOpened == 'movePopUp'){
      this.buttonText = "CREATE & MOVE";
    }else if(this.universalService.popUpToBeOpened == 'copyPopUp'){
      this.buttonText = "CREATE & COPY";
    }else if(this.universalService.popUpToBeOpened == 'create Folder'){
      this.buttonText = "CREATE FOLDER";
    }else if(this.universalService.popUpToBeOpened == "addToJioCloud"){
      this.buttonText = "CREATE AND ADD";
    }
  }

}
